import { render } from "./MetaSlider.vue?vue&type=template&id=57c6b89b"
import script from "./MetaSlider.vue?vue&type=script&lang=js"
export * from "./MetaSlider.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mfeys\\Desktop\\HAv2\\actions\\18597-ocebio\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__